<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设备管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">美陈示例</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsEdit && !showIsAdd">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            @click="showIsAdd = !showIsAdd"
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            >增加</a-button
          >
        </span>
        <span>
          <label>有无边柜：</label>
          <a-radio-group v-model="is_frame">
            <a-radio :value="1">有边柜</a-radio>
            <a-radio :value="2">无边柜</a-radio>
          </a-radio-group>
        </span>
        <span>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td></td>
              <td>
                <p v-show="item.is_frame == 1">有边柜</p>
                <p v-show="item.is_frame == 2">无边柜</p>
              </td>
              <td>
                <viewer :images="item.imageUrl.url_thumb.split(',')">
                  <img
                    class="imgStyle"
                    v-for="src in item.imageUrl.url_thumb.split(',')"
                    :src="src"
                    :key="src"
                  />
                </viewer>
              </td>
              <td class="operation">
                <a @click="editPage(item)" style="color:#67C23A">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 增加 -->
    <addDisplayExample v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end -->
    <!-- 编辑 -->
    <displayExampleEdit
      v-if="showIsEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end -->
  </div>
</template>
<script>
import axios from "axios";
import addDisplayExample from "@/components/equipment/addDisplayExample"; //增加
import displayExampleEdit from "@/components/equipment/displayExampleEdit"; //编辑
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: ["项目名称", "有无边柜", "示例图", "操作"],
      is_frame: "",
      showIsAdd: false,
      proList: [],
      showIsEdit: false,
      editDetail: "",
      showIsDetail: false,
      detailVal: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addDisplayExample,
    displayExampleEdit
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    editPage(item) {
      this.showIsEdit = true;
      this.editDetail = item;
    },
    hideInEdit(msg) {
      this.showIsEdit = false;
      if (msg) {
        this.reload();
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    backHref() {
      this.showIsEdit = false;
      this.showIsAdd = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.is_frame = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Mc_examples/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        is_frame: this.is_frame,
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
